import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { prepareRealtorRatingOrdering, prepareSortOrder } from '../prepareOrdering';
import {
  ERealtorRatingTableColumns,
  REALTOR_RATING_SORT_ORDERING_DEFAULT,
  REALTOR_RATING_SORT_ORDERING_QS_NAME,
  REALTOR_RATING_SORT_ORDERING_TYPE_DEFAULT,
  REALTOR_RATING_SORT_ORDERING_TYPE_QS_NAME,
} from '../../constants';
import { ESortOrder } from '../../types/sortOrder';
import { correctPathname } from '../correctPathname';

/**
 * Сохраняет и считывает сортировку в/из адресной строки
 */
export const useRealtorRatingSortOrdering = () => {
  const { search, pathname } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const history = useHistory();
  const sortOrdering =
    prepareRealtorRatingOrdering(searchParams.get(REALTOR_RATING_SORT_ORDERING_QS_NAME) || '') ||
    REALTOR_RATING_SORT_ORDERING_DEFAULT;
  const sortOrderingType =
    prepareSortOrder(searchParams.get(REALTOR_RATING_SORT_ORDERING_TYPE_QS_NAME) || '') ||
    REALTOR_RATING_SORT_ORDERING_TYPE_DEFAULT;

  /** Устанавливает сортировку в адресную строку */
  const setSortOrdering = useCallback(
    (column: ERealtorRatingTableColumns, sortOrder: ESortOrder) => {
      /** Если оба значения по умолчанию, то удаляем их из qs */
      if (column === REALTOR_RATING_SORT_ORDERING_DEFAULT && sortOrder === REALTOR_RATING_SORT_ORDERING_TYPE_DEFAULT) {
        searchParams.delete(REALTOR_RATING_SORT_ORDERING_QS_NAME);
        searchParams.delete(REALTOR_RATING_SORT_ORDERING_TYPE_QS_NAME);
      } else {
        searchParams.set(REALTOR_RATING_SORT_ORDERING_QS_NAME, column);
        searchParams.set(REALTOR_RATING_SORT_ORDERING_TYPE_QS_NAME, sortOrder);
      }

      history.push(`${correctPathname(pathname)}?${searchParams.toString()}`);
    },
    [history, pathname, searchParams],
  );

  return {
    sortOrdering,
    sortOrderingType,
    setSortOrdering,
  };
};
